import { AlertEnum, ButtonVariantEnum, DateFormatTypeEnum, DropdownButtonTypeEnum, SituacaoEleicaoEnum } from '../../enums';
import { EleicaoResponseType, EleicoesListType } from '../../types';
import {
  initialValuesRemocaoEleicaoModal,
  remocaoEleicaoModalContent,
  validationSchemaRemocaoEleicaoModal,
} from '../remocao-eleicao';
import { useAlert, useAuthAxios, useErrorHandler, useModal } from '../../hooks';

import { ApiHelper } from '../../helpers';
import { DateFormat } from '../../utils';
import { DropdownMenu } from '../../components';
import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const EleicoesList: FunctionComponent<EleicoesListType> = ({
  eleicoes,
  setEleicoes,
  statusLabel,
  colorClass,
  className = '',
}) => {
  const { t } = useTranslation();
  const { confirmModal, confirmModalForm } = useModal();
  const axios = useAuthAxios();
  const errorHandler = useErrorHandler();
  const { createAlert } = useAlert();

  return eleicoes.length > 0 ? (
    <div className={`list-group list-group-classified-${colorClass} ${className}`}>
      <div className="list-group-classified-label">{statusLabel}</div>
      {eleicoes.map((eleicao: EleicaoResponseType) => (
        <Link
          to={`/eleicoes/${eleicao.id}`}
          className="list-group-item list-group-item-action d-flex flex-column flex-md-row align-items-md-center justify-content-between"
          key={eleicao.id}
        >
          <div className={'d-flex flex-column'}>
            <div className="d-flex w-100 justify-content-between">
              <h5 className="mb-1 flex-grow-1">{eleicao.titulo}</h5>
            </div>
            <p className="mb-1">
              <DateFormat originalDate={eleicao.data_inicio} formatType={DateFormatTypeEnum.DATETIME} />
              {' - '}
              <DateFormat originalDate={eleicao.data_fim} formatType={DateFormatTypeEnum.DATETIME} />
            </p>
          </div>

          <div className={'d-flex flex-row justify-content-between'}>
            <div className="align-self-center me-2">
              {eleicao.auditada ? (
                <span className="badge bg-info-600">{t('label.auditada')}</span>
              ) : (
                <span className="badge bg-secondary">{t('label.nao_auditada')}</span>
              )}
            </div>
            <DropdownMenu
              title={t('label.acoes_opcoes')}
              btnType={DropdownButtonTypeEnum.ICON}
              operations={[
                ...(eleicao.situacao === SituacaoEleicaoEnum.NAO_PUBLICADA.key
                  ? [
                      {
                        operation: () => {
                          confirmModal(
                            t('confirmacao.publicar_eleicao'),
                            () => {
                              axios
                                .patch(ApiHelper.getUrl.apiSCE.publicarEleicao(eleicao.id))
                                .then((response) => {
                                  const indexEleicaoPublicada = eleicoes.findIndex((e) => e.id === eleicao.id);
                                  eleicoes.splice(indexEleicaoPublicada, 1, response.data);
                                  createAlert(t('sucesso.publicar_eleicao'), AlertEnum.SUCCESS);
                                })
                                .catch((error) => errorHandler(error, t('erro.publicar_eleicao')));
                            },
                            ButtonVariantEnum.SUCCESS,
                            t('label.publicar_eleicao'),
                          );
                        },
                        title: t('label.publicar_eleicao'),
                      },
                    ]
                  : eleicao.situacao === SituacaoEleicaoEnum.PUBLICADA.key
                    ? [
                        {
                          operation: () => {
                            confirmModal(
                              t('confirmacao.despublicar_eleicao'),
                              () => {
                                axios
                                  .patch(ApiHelper.getUrl.apiSCE.despublicarEleicao(eleicao.id))
                                  .then((response) => {
                                    const indexEleicaoDespublicada = eleicoes.findIndex((e) => e.id === eleicao.id);
                                    eleicoes.splice(indexEleicaoDespublicada, 1, response.data);
                                    createAlert(t('sucesso.despublicar_eleicao'), AlertEnum.SUCCESS);
                                  })
                                  .catch((error) => errorHandler(error, t('erro.despublicar_eleicao')));
                              },
                              ButtonVariantEnum.PRIMARY,
                              t('label.despublicar_eleicao'),
                            );
                          },
                          title: t('label.despublicar_eleicao'),
                        },
                      ]
                    : []),
                {
                  operation: () => {
                    confirmModalForm(
                      remocaoEleicaoModalContent(eleicao, t),
                      initialValuesRemocaoEleicaoModal,
                      validationSchemaRemocaoEleicaoModal(eleicao),
                      () => {
                        axios
                          .delete(ApiHelper.getUrl.apiSCE.eleicao(eleicao.id))
                          .then(() => {
                            setEleicoes(eleicoes.filter((e) => e.id !== eleicao.id));
                            createAlert(t('sucesso.remover_eleicao'), AlertEnum.SUCCESS);
                          })
                          .catch((error) => errorHandler(error, t('erro.remover_eleicao')));
                      },
                      ButtonVariantEnum.DANGER,
                      t('texto.remocao_eleicao'),
                    );
                  },
                  title: t('label.remover_eleicao'),
                },
              ]}
            />
          </div>
        </Link>
      ))}
    </div>
  ) : (
    <></>
  );
};

export default EleicoesList;
